import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddPaymentModule } from '../add-payment/add-payment.module';
import { NewCardModule } from '../new-card/new-card.module';

@NgModule({
  declarations: [AuthComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule.forChild(),
    FormsModule,
    ReactiveFormsModule,
    AddPaymentModule,
    NewCardModule
  ],
  exports: [AuthComponent]
})
export class AuthModule {}
